// Function to set up scroll animations
function setupScrollAnimations() {
  const elements = document.querySelectorAll('.scroll-trigger');

  // If no elements found, return early
  if (elements.length === 0) return;

  // Set up intersection observer
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          const element = entry.target;
          // Remove offscreen class and add animation when element enters viewport
          element.classList.remove('scroll--offscreen');
          if (element.hasAttribute('data-scroll-animation')) {
            element.setAttribute('style', `--animation-order: ${index};`);
          }
          // Stop observing this element
          observer.unobserve(element);
        } else {
          // Add offscreen class to elements not in viewport
          entry.target.classList.add('scroll--offscreen');
        }
      });
    },
    {
      rootMargin: '0px 0px -50px 0px',
    }
  );

  // Start observing all elements
  elements.forEach((element) => {
    observer.observe(element);
  });
}

// Run initial setup
setupScrollAnimations();
